<template>
  <lateral-modal
    :title="$t(fieldMappingModalHeader)"
    @close="closeModal"
  >
    <template slot="content">
      <form
        id="diet-category-form"
        @submit.prevent="submit"
      >
        <div class="row">
          <div class="col-12">
            <div class="input--block input--block--margin">
              <label class="form--label u-required"> {{$t('company_export_settings_create_field_mapping_name').toUpperCase()}}</label>
              <div
                class="Form-field"
                :class="{'Form--field-error': $v.fieldMapping.name.$error}"
              >
                <input
                  class="Input-text"
                  type="text"
                  v-model="fieldMapping.name"
                  @blur="$v.fieldMapping.name.$touch()"
                  :placeholder="$t('company_export_settings_create_field_mapping_name')"
                >
              </div>
            </div>
          </div>
          <div class="Fuell-Export--field-mapping col-12">
            <p
              for=""
              class="Fuell-Text--black"
            >{{$t('company_export_settings_create_field_mapping_correspondence')}}</p>
            <p class="Fuell-Text">
              {{$t('company_export_settings_create_field_mapping_correspondence_subtitle')}}
            </p>
          </div>
          <div class="Fuell-Export--field-mapping col-12">
            <div class="input--block input--block--margin">
              <label
                for=""
                class="form--label"
                :class="{'u-required': !fieldMapping.regionSelected.id && !fieldMapping.categorySelected.id}"
              >{{
                $t('company_export_settings_create_field_mapping_region').toUpperCase()
              }}</label>
              <div class="multiselect-filter">
                <multi-select-input
                  :options="vatRegions"
                  :placeholder="$t('company_export_settings_create_field_mapping_region')"
                  :value="fieldMapping.regionSelected"
                  :trackBy="'id'"
                  :emitFullValue="true"
                  :customLabelField="'place'"
                  id="transaction-budget-selector"
                  searchable
                  @inputSelected="setRegion($event)"
                ></multi-select-input>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="input-block input--block--margin input--block--padded h-100">
              <div
                v-for="(vatType, index) in vatTypes"
                :key="index"
              >
                <div class="d-flex justify-content-between">
                  <div class="d-flex flex-column">
                    <label
                      class="form--label pl-2"
                      v-if="index === 0"
                    >
                      {{ $t('company_export_settings_create_field_mapping_fuell').toUpperCase() }}
                    </label>
                    <div class="Form-field Form-field--white Form-field--short position-relative">
                      <span class="Fuell-Text">{{vatTypesFuell[index].fuellValue}}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-column">
                    <label
                      class="form--label pl-2"
                      v-if="index === 0"
                    >
                      {{ $t('company_export_settings_create_field_mapping_export').toUpperCase() }}</label>
                    <div class="Form-field Form-field--short position-relative arrow-icon">
                      <input
                        class="Input-text"
                        type="number"
                        v-model="vatType[`vatType${index + 1}`]"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="categoriesReady"
            class="col-12"
          >
            <div class="input--block input--block--margin input--block--padded">
              <label
                for="transaction-category-input"
                class="form--label"
                :class="{'u-required': !fieldMapping.regionSelected.id && !fieldMapping.categorySelected.id}"
              >
                {{
                    $t('company_export_settings_create_field_mapping_category').toUpperCase()
                  }}
              </label>
              <div class="multiselect-filter">
                <multi-select-input
                  :options="categories"
                  :placeholder="$t('company_export_settings_create_field_mapping_category')"
                  :value="fieldMapping.categorySelected"
                  :trackBy="'id'"
                  :emitFullValue="true"
                  :customLabelField="'name'"
                  id="transaction-budget-selector"
                  searchable
                  @inputSelected="setCategory($event)"
                ></multi-select-input>
              </div>
            </div>
          </div>
          <div
            v-if="categoriesReady"
            class="col-12 mt-1"
          >
            <div class="input-block input--block--margin input--block--paded h-100">

              <div
                class="d-flex justify-content-between"
                v-for="(customCategory, index) in fieldMapping.categorySelected.customCategories || []"
                :key="index"
              >
                <div class="d-flex flex-column">
                  <label
                    class="form--label pl-2"
                    v-if="index === 0"
                  >
                    {{ $t('company_export_settings_create_field_mapping_fuell').toUpperCase() }}
                  </label>
                  <div class="Form-field Form-field--white Form-field--short position-relative">
                    <span class="Fuell-Text">{{customCategory.name}}</span>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <label
                    class="form--label pl-2"
                    v-if="index === 0"
                  >
                    {{ $t('company_export_settings_create_field_mapping_export').toUpperCase() }}</label>
                  <div class="Form-field Form-field--short position-relative arrow-icon">
                    <input
                      class="Input-text"
                      type="text"
                      v-model="customCategory.exportValue"
                      @blur="$v.fieldMapping.name.$touch()"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        v-if="isLoading"
        class="w-100 d-flex justify-content-center"
      >
        <spinner />
      </div>
    </template>
    <template slot="footer">
      <button
        class="Fuell-Button blue block"
        :class="{'Fuell-Button--disabled' : !canBeSubmitted}"
        :disabled="!canBeSubmitted"
        type="submit"
        form="diet-category-form"
      >
        <span class="Fuell-Button--label">
          {{$t(fieldMappingConfirmButtonLabel)}}
        </span>
      </button>
    </template>
  </lateral-modal>

</template>

<script>
import Spinner from '@/components/Commons/Spinner'
import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import LateralModal from '@/components/Commons/Modals/LateralModal'

import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'

const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')

export default {
  name: 'CreateFieldMappingModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: {
    MultiSelectInput,
    Spinner,
    LateralModal
  },
  props: {
    fieldMappingId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      fieldMapping: {
        name: '',
        regionSelected: {},
        categorySelected: {}
      },
      vatTypes: [],
      vatTypesFuell: [],
      isLoading: false,
      categoriesReady: false
    }
  },
  computed: {
    regionSelectedId () {
      return toString(this.fieldMapping?.regionSelected?.vatType?.id?.toString()) || this.fieldMapping?.regionSelected?.id
    },
    canBeSubmitted () {
      return !this.$v.$invalid
    },
    fieldMappingModalHeader () {
      return this.fieldMappingId ? 'company_export_settings_edit_field_mapping_modal_header' : 'company_export_settings_create_field_mapping_modal_header'
    },
    fieldMappingConfirmButtonLabel () {
      return this.fieldMappingId ? 'company_export_settings_edit_field_mapping_modal_confirm' : 'company_export_settings_create_field_mapping_modal_confirm'
    },
    fieldMappingData () {
      return this.$store.getters['CompanyStore/ExportSettingsStore/fieldMapping']
    },
    vatRegions () {
      return this.$store.getters['TransactionsStore/vatTypes']
    },
    categories () {
      return this.$store.getters['CategoriesStore/categories'] || []
    },
    customCategories () {
      return this.$store.getters['CategoriesStore/customCategories'] || []
    },
    defaultCategoriesOffice () {
      return this.$store.getters['CategoriesStore/defaultCategoriesOffice'] || []
    }
  },
  methods: {
    manageFormData () {
      let mappingConfiguration = {
        name: this.fieldMapping.name,
        vatTypeMapping: {
          vatType: {
            id: this.fieldMapping.regionSelected?.id
          }
        },
        categoryMappings:
          this.fieldMapping.categorySelected.customCategories.map(item => {
            return {
              name: item.exportValue,
              accountNumber: item.accountNumber,
              taxCode: parseFloat(item.taxCode),
              customCategory: {
                id: item.id
              },
              defaultCategoryOffice: {
                id: this.fieldMapping.categorySelected.defaultCategoryOffice.id
              }
            }
          })
      }
      this.vatTypes.forEach(item => {
        mappingConfiguration.vatTypeMapping = { ...mappingConfiguration.vatTypeMapping, ...item }
      })
      Object.keys(mappingConfiguration.vatTypeMapping).forEach(key => {
        if (typeof mappingConfiguration.vatTypeMapping[key] === 'string') {
          mappingConfiguration.vatTypeMapping[key] = parseFloat(mappingConfiguration.vatTypeMapping[key])
        }
      })
      return mappingConfiguration
    },
    async submit () {
      if (!this.canBeSubmitted) return
      if (!this.fieldMappingId) {
        await this.$store.dispatch('CompanyStore/ExportSettingsStore/createFieldMapping', this.manageFormData())
      } else {
        await this.$store.dispatch('CompanyStore/ExportSettingsStore/updateFieldMapping', { id: this.fieldMappingId, info: this.manageFormData() })
      }
      this.closeModal()
    },
    setRegion (region) {
      const regionToCopy = region && region.vatType ? region.vatType : region
      this.fieldMapping.regionSelected = regionToCopy
      this.vatTypes = []
      this.vatTypesFuell = []
      Object.keys(regionToCopy).forEach(key => {
        if (key !== 'vatType' && key.includes('vatType') && regionToCopy[key]) {
          this.vatTypes.push({
            [key]: region[key]
          })
          this.vatTypesFuell.push({
            fuellValue: regionToCopy[key]
          })
        }
      })
    },
    setCategory (category) {
      this.fieldMapping.categorySelected = category
    },
    mergeDefaultCategoriesOffice () {
      this.categories.forEach(category => {
        let defaultCategoryOffice = this.defaultCategoriesOffice.find(item => item.id === category.id)
        category.defaultCategoryOffice = defaultCategoryOffice || {}
      })
    },
    mergeCustomCategories () {
      this.categories.forEach(category => {
        let customCategories = this.customCategories.filter(item => item.defaultCategoryOffice?.id === category.id)

        category.customCategories = customCategories || {}
      })
    },
    initializeFieldMapping () {
      if (this.fieldMappingId) {
        this.fieldMapping.name = this.fieldMappingData.name
        this.setRegion(this.fieldMappingData.vatTypeMapping)
        this.fieldMapping.categorySelected = this.categories.find(item => item.defaultCategoryOffice.id === this.fieldMappingData.categoryMappings[0].defaultCategoryOffice.id)
        this.fieldMappingData.categoryMappings.forEach((item, index) => {
          this.fieldMapping.categorySelected.customCategories[index].exportValue = item.name
        })
      }
    }
  },
  validations () {
    if (!this.fieldMapping.regionSelected?.id && !this.fieldMapping.categorySelected?.id) {
      return {
        fieldMapping: {
          name: { required },
          regionSelected: { required },
          categorySelected: { required }
        }
      }
    } else {
      return {
        fieldMapping: {
          name: { required }
        }
      }
    }
  },
  async created () {
    let promises = [this.$store.dispatch('CategoriesStore/fetchCustomCategories', false), this.$store.dispatch('CategoriesStore/fetchDefaultCategoriesOffice')]
    if (this.fieldMappingId) {
      promises.push(this.$store.dispatch('CompanyStore/ExportSettingsStore/getFieldMapping', this.fieldMappingId))
    }
    Promise.allSettled(promises).then(() => {
      this.mergeDefaultCategoriesOffice()
      this.mergeCustomCategories()
      this.initializeFieldMapping()
      this.categoriesReady = true
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  }

}
</script>

<style lang="scss" scoped>
.arrow-icon {
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 17px;
    left: -17px;
    width: 6px;
    height: 10px;
    background-image: url("~@/assets/img/icons/icon-arrow.svg");
    background-size: 100%;
    background-repeat: no-repeat;
  }
}
.Fuell-Export--field-mapping {
  margin-top: 22px;
}
.Fuell-Text {
  margin-bottom: 10px;
}

.Button {
  max-width: 210px;
}
</style>
